import { c as _c } from "react/compiler-runtime";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MuiMenu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import compact from 'lodash/compact';
import { useRouter } from 'next/compat/router';
import NextLink from 'next/link';
import { useTranslation } from 'next-i18next/pages';
import { type MouseEvent, type ReactElement, useState } from 'react';
import { useFlags } from '@core/shared/ui/FlagsProvider';
import ChervonDownIcon from '@core/shared/ui/icons/ChevronDown';
import JourneysIcon from '@core/shared/ui/icons/Journeys';
import MetaverseIcon from '@core/shared/ui/icons/Metaverse';
import Play1Icon from '@core/shared/ui/icons/Play1';
import TerminalIcon from '@core/shared/ui/icons/Terminal';
export function HeaderTabButtons() {
  const $ = _c(4);
  const {
    strategies,
    journeys
  } = useFlags();
  const {
    t
  } = useTranslation("apps-resources");
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Play1Icon />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MetaverseIcon />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const headerItems = compact([strategies ? {
    label: t("Resources", {
      lng: "en"
    }),
    icon: <TerminalIcon />,
    href: "/resources"
  } : undefined, journeys ? {
    label: t("Journeys", {
      lng: "en"
    }),
    icon: <JourneysIcon />,
    href: "/journeys"
  } : undefined, {
    label: t("Watch", {
      lng: "en"
    }),
    icon: t0,
    href: "/watch"
  }, {
    label: t("Metaverse", {
      lng: "en"
    }),
    icon: t1,
    href: "https://www.jesusfilm.org/metaverse/"
  }]);
  const [anchorEl, setAnchorEl] = useState(null);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function handleShowMenu(event) {
      setAnchorEl(event.currentTarget);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleShowMenu = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = function handleCloseMenu() {
      setAnchorEl(null);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleCloseMenu = t3;
  const buttonLabel = headerItems.find(link => router?.pathname?.startsWith(link.href))?.label ?? "";
  const buttonIcon = headerItems.find(link_0 => router?.pathname?.startsWith(link_0.href))?.icon ?? <Play1Icon />;
  return headerItems.length > 1 ? <><Box data-testid="HeaderTabButtons" sx={{
      display: {
        xs: "none",
        md: "flex"
      },
      width: "100%",
      height: "48px",
      justifyContent: "space-between",
      gap: {
        sm: "8px",
        md: "12px"
      },
      alignItems: "center"
    }}>{headerItems.map(t4 => {
        const {
          label,
          icon,
          href
        } = t4;
        return <Button data-testid={`${label}Button`} color="inherit" component={NextLink} href={href} key={label} sx={{
          flexGrow: 1,
          textAlign: "center",
          borderRadius: "40px !important",
          border: "2px solid",
          borderColor: router?.pathname?.startsWith(href) ?? false ? _temp : "transparent",
          py: {
            sm: 1
          },
          px: {
            sm: 2
          },
          fontSize: {
            sm: "0.875rem",
            md: "1rem"
          }
        }} startIcon={icon} locale={false}>{label}</Button>;
      })}</Box><Box sx={{
      top: "-10px",
      pr: {
        md: "20px"
      },
      display: {
        xs: "flex",
        md: "none"
      },
      justifyContent: "center",
      width: "100%"
    }}><Button fullWidth={true} data-testid="DropDownButton" color="inherit" onClick={handleShowMenu} sx={{
        borderRadius: "40px !important",
        borderWidth: "2px",
        borderStyle: "solid",
        borderColor: "text.disabled",
        backgroundColor: "background.default",
        "&:hover": {
          backgroundColor: "background.default"
        },
        height: "48px",
        position: "relative"
      }}><Stack direction="row" sx={{
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%"
        }}>{buttonIcon}<Typography variant="inherit">{buttonLabel}</Typography><ChervonDownIcon data-testid="ChevronDownIcon" /></Stack></Button></Box><MuiMenu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu} keepMounted={true} slotProps={{
      paper: {
        style: {
          width: anchorEl?.clientWidth
        }
      }
    }}>{headerItems.map(t5 => {
        const {
          label: label_0,
          icon: icon_0,
          href: href_0
        } = t5;
        return <MenuItem key={label_0} component={NextLink} href={href_0} locale={false} onClick={handleCloseMenu} selected={router?.pathname?.startsWith(href_0)}><Stack direction="row" sx={{
            alignItems: "center",
            width: "100%",
            px: 2.5
          }}><ListItemIcon>{icon_0}</ListItemIcon><ListItemText primary={label_0} slotProps={{
              primary: {
                variant: "h6",
                sx: {
                  textAlign: "center"
                }
              }
            }} /><Box sx={{
              width: 30
            }} /></Stack></MenuItem>;
      })}</MuiMenu></> : <></>;
}
function _temp(theme) {
  return theme.palette.primary.main;
}